import { cn } from "./_utils";

type StatusTagKind =
  | "incident"
  | "stuck"
  | "resolved"
  | "deploy"
  | "send"
  | "declined"
  | "signal";

const KIND_CLASS: Record<StatusTagKind, string> = {
  incident: "status-stamp--incident",
  send: "status-stamp--send",
  stuck: "status-stamp--stuck",
  resolved: "",
  deploy: "",
  declined: "status-stamp--declined",
  signal: "status-stamp--signal",
};

type StatusTagProps = React.HTMLAttributes<HTMLSpanElement> & {
  kind?: StatusTagKind;
};

/**
 * Typographic status stamp (mono caps) — INCIDENT, STUCK, RESOLVED, DEPLOY,
 * SEND, DECLINED, NEW SIGNAL. The INCIDENT tag is the only red allowed on a
 * screen; urgency comes from content and hierarchy, never a red wash.
 *
 * @example
 * <StatusTag kind="incident" />
 * <StatusTag kind="stuck">STUCK</StatusTag>
 * <StatusTag kind="signal">NEW SIGNAL</StatusTag>
 */
export function StatusTag({
  kind = "resolved",
  className,
  children,
  ...props
}: StatusTagProps) {
  return (
    <span
      className={cn("status-stamp", KIND_CLASS[kind], className)}
      {...props}
    >
      {children ?? kind.toUpperCase()}
    </span>
  );
}

export type { StatusTagKind, StatusTagProps };
